(function () {
  const trackedElements = new Map();

  function updateVisibility() {
    const isMobile = window.innerWidth < 750;

    // Loop through all .custom-mob-data elements in DOM
    document.querySelectorAll('.custom-mob-data').forEach(el => {
      if (!trackedElements.has(el)) {
        // Track only the first time
        trackedElements.set(el, {
          html: el.outerHTML,
          parent: el.parentNode,
          nextSibling: el.nextSibling
        });
      }

      if (!isMobile && el.isConnected) {
        el.remove(); // Safely remove from DOM
      }
    });

    // Reinsert only if screen < 750 and element is not present in parent
    if (isMobile) {
      for (const [key, { html, parent, nextSibling }] of trackedElements) {
        if (!parent.querySelector('.custom-mob-data')) {
          const temp = document.createElement('div');
          temp.innerHTML = html;
          const newEl = temp.firstElementChild;
          if (newEl) {
            parent.insertBefore(newEl, nextSibling);
          }
        }
      }
    }
  }

  // Observe dynamic changes
  const observer = new MutationObserver(() => {
    updateVisibility();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Regular interval check
  setInterval(updateVisibility, 100);

  // Resize event check
  window.addEventListener('resize', updateVisibility);

  // Initial run
  updateVisibility();
})();
